import { Icon } from '@/icons/Icon'

export function iconMap(title: string) {
  const t = title.toLowerCase()

  if (t.includes('what is')) {
    return <Icon name="what-is" />
  }
  if (t.includes('compare')) {
    return <Icon name="wand-sparkle" />
  }
  if (t.includes('pros')) {
    return <Icon name="pros-cons" />
  }
  if (t.includes('features')) {
    return <Icon name="key-features" />
  }
  if (t.includes('verdict')) {
    return <Icon name="best" />
  }
  if (t.includes('pricing')) {
    return <Icon name="money-bill-coin" />
  }
  if (t.includes('the problem with')) {
    return <Icon name="tag" />
  }
  if (t.includes('when to use')) {
    return <Icon name="gem-sparkle" />
  }

  return <Icon name="circle-info" />
}
